import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../api";

export default function PushpayCallback() {
  const [searchParams] = useSearchParams();
  const hasCode = Boolean(searchParams.get("code"));
  const hasError = Boolean(searchParams.get("error"));
  const [status, setStatus] = React.useState<"idle" | "working" | "success" | "error">(
    hasError ? "error" : hasCode ? "working" : "idle"
  );
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    if (hasError) {
      setMessage(searchParams.get("error_description") || searchParams.get("error") || "Pushpay returned an error.");
      return;
    }
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    if (!code || !state) return;

    let isActive = true;
    const completeConnection = async () => {
      setStatus("working");
      try {
        const response = await api.get("/integrations/pushpay/callback", {
          params: { code, state },
        });
        if (!isActive) return;
        setStatus("success");
        setMessage(response.data?.message || "Pushpay ChMS connected.");
      } catch (error: any) {
        if (!isActive) return;
        setStatus("error");
        setMessage(
          error?.response?.data?.detail ||
            error?.message ||
            "Could not complete the Pushpay ChMS connection."
        );
      }
    };

    void completeConnection();

    return () => {
      isActive = false;
    };
  }, [hasCode, hasError, searchParams]);

  const isSuccess = status === "success";
  const isError = status === "error";

  return (
    <main
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        color: "#111827",
        display: "grid",
        placeItems: "center",
        padding: 24,
        fontFamily:
          "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <section
        style={{
          width: "min(560px, 100%)",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          background: "#fff",
          padding: 24,
          boxShadow: "0 18px 42px rgba(15, 23, 42, 0.08)",
          display: "grid",
          gap: 12,
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 900,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: isError ? "#b91c1c" : isSuccess ? "#047857" : "#64748b",
          }}
        >
          Pushpay ChMS
        </div>
        <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.1 }}>
          {isError
            ? "Connection was not completed"
            : isSuccess
              ? "Connection complete"
              : status === "working"
                ? "Finishing connection"
              : "Pushpay callback ready"}
        </h1>
        <p style={{ margin: 0, color: "#4b5563", lineHeight: 1.55, fontSize: 15 }}>
          {message ||
            (isError
              ? "Pushpay returned an error instead of an authorization code. You can return to Lenses and try connecting again."
              : status === "working"
                ? "Lenses received the Pushpay authorization response and is exchanging it for a secure API token."
              : "This URL is available for Pushpay OAuth redirects. Use the exact HTTPS URL when registering the Pushpay app callback.")}
        </p>
        <div
          style={{
            border: "1px solid #dbeafe",
            borderRadius: 10,
            background: "#eff6ff",
            color: "#1e3a8a",
            padding: "10px 12px",
            fontSize: 13,
            fontWeight: 800,
            overflowWrap: "anywhere",
          }}
        >
          https://www.lensescpm.com/integrations/pushpay/callback
        </div>
        <Link
          to="/"
          style={{
            justifySelf: "start",
            marginTop: 4,
            border: "1px solid #111827",
            borderRadius: 9,
            padding: "10px 12px",
            background: "#111827",
            color: "#fff",
            textDecoration: "none",
            fontSize: 14,
            fontWeight: 850,
          }}
        >
          Return to Lenses
        </Link>
      </section>
    </main>
  );
}
